import React, { useContext } from 'react';
import { useCompanyFeedback } from 'src/queries/feedback';
import commonDateUtils from 'common/commonDateUtils';
import { PerformanceBuilderContext } from 'src/pages/PerformanceBuilder/PerformanceBuilderContext';
import FeedbackFeed from 'src/containers/UserProfile/FeedbackDashboard/components/FeedbackFeed';
import FilterView from 'src/containers/UserProfile/FilterView/FilterView';
import { Pagination } from 'src/components/index';
import commonPermissions from 'common/commonPermissions';

const BuilderTeamFeedback = () => {
  const {
    data: { form, prevDataRef, feedbacksCurrentPage },
    setDataAttribute
  } = useContext(PerformanceBuilderContext);

  const prevData = prevDataRef.current;

  const { watch } = form;
  const currData = watch();
  const feedbackFilters = {
    author: null,
    category: null,
    includeUnassignedUsers: false,
    managerId: null,
    recipient: currData.revieweeId,
    revieweeGroup: null,
    reviewerGroup: null,
    reviewerIds: null,
    roles: null,
    sentiment: null,
    start: commonDateUtils.dateToUnix('2020-01-01'),
    end: commonDateUtils.dateToUnix(currData.reviewDate)
  };

  const options = {
    page: feedbacksCurrentPage,
    size: 10
  };

  const {
    data: { feedbacks, pagination } = {},
    isFetching: isFetchingFeedbacks,
    isRefetching: isRefetchingFeedbacks,
    isError: isErrorFeedbacks
  } = useCompanyFeedback(
    { ...feedbackFilters, options },
    { keepPreviousData: true }
  );
  const isInitialFetchingFeedbacks = isFetchingFeedbacks && !isRefetchingFeedbacks;

  const isReady = !isInitialFetchingFeedbacks && !isErrorFeedbacks && pagination;

  if (!isReady) {
    return;
  }

  const selectPage = (page) => {
    setDataAttribute('feedbacksCurrentPage', parseInt(page, 10));
  };
  /* const canViewFeedback = !commonPermissions.canViewFeedback({
    tree,
    revieweeId: reviewee._id,
    reviewerId: reviewer._id,
    account: loggedAccount
  }); */
  return (
    <div className='flex flex-col w-full'>
      <div
        id='review-template-section'
        className='mb-6 border-b border-[#E2E8F0]'
      />
      {/* <FilterView
        show={[
          'date'
        ]}
        displayClearFiltersBtn={false}
        customContext={PerformanceBuilderContext}
        classes='!w-full !justify-end'
        wrapperClasses='ml-0 pl-0'
        selectClasses='!w-full'
      /> */}
      <FeedbackFeed
        feedbacks={feedbacks}
        reviewee={{
          id: prevData.revieweeId,
          name: prevData.revieweeFirstName,
          label: prevData.revieweeFirstName
        }}
        isLoading={isFetchingFeedbacks}
        emptyText='No historic feedback available.'
        showUserSelect
        renderPagination={() => (
          <div className='mt-4'>
            <Pagination
              name='UserFeedback'
              totalPages={pagination.pages}
              currentPage={pagination.current}
              selectPage={selectPage}
              isLoading={isFetchingFeedbacks}
            />
          </div>
        )}
      />
    </div>
  );
};

export default BuilderTeamFeedback;
